import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import ChatStore from 'stores/ChatStore';

import DesktopChatV2 from '../../../DesktopChatV2/DesktopChatV2';

import styles from './Conversation.css';


function Conversation(props) {
  const { activeConversationKey, children } = props;

  const { privateChatSessionData: { roomName } } = ChatStore;

  return (
    <div
      aria-labelledby={`vertical-tab-${activeConversationKey}`}
      className={styles.conversationPanel}
      id={`vertical-tabpanel-${activeConversationKey}`}
      role="tabpanel"
    >
      {children}
      <DesktopChatV2
        {...props}
        isGroupShowChat={false}
        isPrivateUserChat={true}
        recipient={activeConversationKey}
        roomName={roomName}
      />
    </div>
  );
}

Conversation.propTypes = {
  activeConversationKey: PropTypes.string.isRequired,
  children: PropTypes.object,
};

Conversation.defaultProps = { children: null };

export default observer(Conversation);
